<div class="padding-bottom-25">
  <div>
    <h1 mat-dialog-title>{{ data.title }}</h1>
  </div>
  <div mat-dialog-content *ngFor="let details of data.details">
    <p class="dialog-message">{{ details.message }}</p>
    <ul *ngIf="details.value">
      <li *ngFor="let value of details.value">{{value}}</li>
    </ul>
    <ul *ngIf="details.links && details.links.length" class="alert-dialog-links">
      <li *ngFor="let link of details.links">
        <a href="#" (click)="openLink($event, link.url)">{{link.label}}</a>
      </li>
    </ul>
  </div>

  <mat-dialog-actions>
    <button class="btn btn-cancel" (click)="close(false)">Close</button>
    <button *ngIf="data.confirmText" class="btn btn-confirm" (click)="confirm()">{{ data.confirmText }}</button>
  </mat-dialog-actions>
</div>
